let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("llprT")).then(() => parcelRequire('58Kxq'));